<template>
  <div>
    <div class="hotListContainer" style="margin-top: 60px;display: flex;">
      <div class="japaneseHotCommodity" style="margin-right: 30px">
        <div class="flexAndCenter" style="display: flex; justify-content: space-between">
          <div class="goodsType">
            <div>Amazon売れ筋</div>
            <img alt="" src="../../assets/img/1688/hot.gif">
          </div>
          <div class="childsContainer" style="margin-right: 30px">
            <div class="childsItemContainer">
              <el-select v-model="leftValue" style="width: 190px" @change="leftOptionChange">
                <el-option v-for="item in leftOption" :key="item.id" :label="item.translate_name"
                  :value="item.chinese_name">
                </el-option>
              </el-select>
            </div>
            <div class="childsItemContainer" style="margin-left: 10px;">
              <el-select v-model="leftFrom.keywords" style="width: 190px" @change="getLeftHotSaleSearch">
                <el-option v-for="item in leftChildrenOption" :key="item.id" :label="item.translate_name"
                  :value="item.chinese_name">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div style="padding-right:30px">
          <div v-loading="leftFullscreenLoading">
            <div v-for="(item, index) in leftList" :key="index" class="goodItemContainer"
              @click="toCommodityDetails(item.goodsId, item.shopType)">
              <img :src="item.imgUrl" alt="" class="goods_pic">
              <div class="goodItemBottomContainer">
                <div :title="item.goods_title" class="goodsTitle">
                  <span v-if="item.shopType == 1688" class="type">1688</span>
                  {{ item.titleT }}
                </div>
                <div class="newPriceContainer">
                  <div>{{ item.goodsPrice }}元（{{ (item.goodsPrice * exchangeRate).toFixed(0) }}
                    円
                    ）
                  </div>
                  <div v-if="item.shopType == 1688"><span style="color: #999999!important">月販売数<span>{{
                item.monthSold
              }}</span>件</span></div>
                </div>
              </div>
            </div>
            <div class="pageSwitchContainer">
              <div class="furnishText">1688 より、情報サポートを受けて提供させて頂いております</div>
              <div class="pageNum">
                <div> {{ leftFrom.page }} ページ目</div>
                <div><span @click="updatePage('left', 'minus')">
                    < </span><span @click="updatePage('left', 'add')"> > </span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="japaneseHotCommodity">
        <div class="flexAndCenter" style=" display: flex;justify-content: space-between;padding-right: 30px">
          <div class="goodsType">
            <div>楽天売れ筋</div>
            <img alt="" src="../../assets/img/1688/hot.gif">
          </div>
          <div class="childsContainer">
            <div class="childsItemContainer">
              <el-select v-model="rightValue" style="width: 190px" @change="rightOptionChange">
                <el-option v-for="item in rightOption" :key="item.id" :label="item.translate_name"
                  :value="item.chinese_name">
                </el-option>
              </el-select>
            </div>
            <div class="childsItemContainer" style="margin-left: 10px">
              <el-select v-model="rightFrom.keywords" style="width: 190px" @change="getRightHotSaleSearch">
                <el-option v-for="item in rightChildrenOption" :key="item.id" :label="item.translate_name"
                  :value="item.chinese_name">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div style="padding-right:30px">
          <div v-loading="rightFullscreenLoading">
            <div v-for="(item, index) in rightList" :key="index" class="goodItemContainer"
              @click="toCommodityDetails(item.goodsId, item.shopType)">
              <img :src="item.imgUrl" alt="" class="goods_pic">
              <div class="goodItemBottomContainer">
                <div :title="item.goods_title" class="goodsTitle">
                  <span v-if="item.shopType == 1688" class="type">1688</span>
                  {{ item.titleT }}
                </div>
                <div class="newPriceContainer">
                  <div>{{ item.goodsPrice }}元 （{{ (item.goodsPrice * exchangeRate).toFixed(0) }}円）
                  </div>
                  <div v-if="item.shopType == 1688"><span style="color: #999999!important">月販売数<span>{{
                item.monthSold
              }}</span>件</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="pageSwitchContainer">
            <div class="furnishText">1688 より、情報サポートを受けて提供させて頂いております</div>
            <div class="pageNum">
              <div>{{ rightFrom.page }} ページ目</div>
              <div><span @click="updatePage('right', 'minus')">
                  < </span><span @click="updatePage('right','add')"> > </span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import { hotSaleCates, hotSaleSearch } from '../../api/API/home'
export default {
  data() {
    return {
      goodsList: [],
      autoplay: true,
      rightFullscreenLoading: false,
      leftFullscreenLoading: false,
      translation_name: "",
      chinese_name: "",
      list: [],
      leftTotal: 0,
      leftFrom: {
        keywords: '',
        type: 'left',
        page: 1,
      },
      rightFrom: {
        keywords: '',
        type: 'right',
        page: 1,
      },
      leftValue: '',
      rightValue: '',
      leftOption: [],
      leftChildrenOption: [],
      rightOption: [],
      rightChildrenOption: [],
      leftList: [],
      rightList: [],
      rightTotal: 0
    };
  },
  components: {

  },
  computed: {
    exchangeRate() {
      let exchangeRate = this.$store.state.exchangeRate
      return Number(exchangeRate)
    },
  },
  created() {
    hotSaleCates().then((res) => {
      console.log(res);
      if (res.code != 0) return this.$message.error(res.msg)
      this.leftFrom.keywords = res.data[0].childs[0].chinese_name;
      this.rightFrom.keywords = JSON.parse(JSON.stringify(res.data[1].childs[0].chinese_name));
      this.leftValue = res.data[0].chinese_name;
      this.rightValue = JSON.parse(JSON.stringify(res.data[1].chinese_name))
      this.leftOption = res.data;
      this.leftChildrenOption = res.data[0].childs;
      this.rightOption = res.data;
      this.rightChildrenOption = res.data[1].childs;
      this.getLeftHotSaleSearch();
      this.getRightHotSaleSearch();
    });
  },
  methods: {
    getLeftHotSaleSearch() {
      this.leftFullscreenLoading = true;
      hotSaleSearch(this.leftFrom).then((res) => {
        this.leftFullscreenLoading = false;
        if (res.code != 0) return this.$message.error(res.msg);
        this.leftList = res.data.result.result;
        this.leftTotal = res.data.result.total;
      });
    },
    getRightHotSaleSearch() {
      this.rightFullscreenLoading = true;
      hotSaleSearch(this.rightFrom).then((res) => {
        this.rightFullscreenLoading = false;
        if (res.code != 0) return this.$message.error(res.msg);
        this.rightList = res.data.result.result;
        this.rightTotal = res.data.result.total;
      });
    },
    leftOptionChange(e) {
      for (let i = 0; i < this.leftOption.length; i++) {
        if (e == this.leftOption[i].chinese_name) {
          this.leftChildrenOption = this.leftOption[i].childs;
          this.leftFrom.keywords = this.leftOption[i].childs[0].chinese_name;
          this.getLeftHotSaleSearch();
        }
      }

    },
    rightOptionChange(e) {
      for (let i = 0; i < this.rightOption.length; i++) {
        if (e == this.rightOption[i].chinese_name) {
          this.rightChildrenOption = this.rightOption[i].childs;
          this.rightFrom.keywords = this.rightOption[i].childs[0].chinese_name;
          this.getRightHotSaleSearch();
        }
      }

    },
    updatePage(direction, type) {

      if (direction === 'left') {
        if (type == 'add') {
          if (this.leftTotal < 6) return this.$message.error('最終ページ')
          this.leftFrom.page++
          this.getLeftHotSaleSearch()
        } else {
          if (this.leftFrom.page == 1) return this.$message.error('現在1ページ目')
          this.leftFrom.page--
          this.getLeftHotSaleSearch()
        }
      } else {
        if (type == 'add') {
          if (this.rightTotal < 6) return this.$message.error('最終ページ')
          this.rightFrom.page++
          this.getRightHotSaleSearch()
        } else {
          if (this.rightFrom.page == 1) return this.$message.error('現在1ページ目')
          this.rightFrom.page--
          this.getRightHotSaleSearch()
        }
      }
    },
    // 跳转
    toCommodityDetails(iid, type) {
      let routeUrl = this.$router.resolve({
        path: "/details1688?iid=" + iid + "&type=" + type,
      });
      window.open(routeUrl.href, "_blank");
    },
    // 数据处理
    ProcessingShopData() {
      //console.log(23);
      let lack = 6 - (this.goodsList.length % 6); //取得店铺商品数离6个的倍数差多少个商品的数量
      //差多少个就从最前面取多少个填充到最后
      for (let i = 0; i < lack; i++) {
        this.goodsList.push(this.goodsList[i]);
      }
      //  分成六个一组
      this.goodsList = this.$fun.changeArr(this.goodsList, 6);
      this.$forceUpdate();
    },
    // 滑动店铺商品列表
    shopCarouselChange(type) {
      if (type == "left") {
        this.$refs.shopCarousel.prev();
      } else if (type == "right") {
        this.$refs.shopCarousel.next();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin.scss";

.type {
  width: 46px;
  height: 18px;
  display: inline-block;
  background: #FF4000;
  border-radius: 2px;
  margin-right: 7px;
  text-align: center;
  line-height: 18px;
  font-weight: bold;
  color: #fff;
}

.recommendGoodsMain {
  width: $pageWidth;
  margin: 100px auto;

  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;

    h4 {
      color: #333333;
      font-size: 24px;
      font-weight: 600;
    }

    .iconBox {
      display: flex;
      align-items: center;

      div {
        width: 42px;
        height: 42px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
          width: 12px;
          height: 20px;
        }
      }

      div:first-child {
        margin-right: 12px;
      }
    }
  }

  .recommendGoodsBox {
    display: flex;

    .recommendGoods {
      cursor: pointer;
      width: 265px;
      height: 356px;
      min-width: 265px;
      min-height: 356px;
      background-color: white;
      border: 1px solid #DFDFDF;
      border-radius: 6px;
      margin-right: 18px;
      transition: 0.3s;
      position: relative;
      overflow: hidden;

      .topThreeIcon {
        position: absolute;
        top: 0;
        right: 0;
      }

      .imageBox {
        width: 100%;
        height: 255px;
        margin-bottom: 5px;
        text-align: center;
        background-color: white;
        overflow: hidden;

        /deep/ .el-image {
          $imgSize: 255px;
          width: 265px;
          height: $imgSize;
          transition: 0.3s;
          text-align: center;

          i {
            font-size: $imgSize/4;
            line-height: $imgSize;
          }
        }
      }

      .goodsTitle {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 5px;
        color: #000000;
        font-family: "Open Sans", Sans-serif;
        font-size: 14px;
      }

      .priceContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .priceBox {
          color: #B4272D;
          font-size: 18px;
        }
      }

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 0 15px rgb(223, 223, 223);
      }
    }

    .recommendGoods:first-child {
      margin-left: 0;
    }

    .recommendGoods:last-child {
      margin-right: 0;
    }
  }

  .lookMore {
    padding: 22px 34px;
    text-align: right;
    color: #1a289d;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;

    i {
      font-weight: 800;
      font-size: 14px;
    }
  }
}

.hotListContainer {
  width: $pageWidth;
  margin: 0 auto 100px;

  .hotListHeaderContainer,
  .hotListFooterContainer {
    display: flex;
    align-items: center;
  }

  .japaneseHotCommodity {
    padding: 14px 0 18px 30px;
    box-sizing: border-box;
    width: 685px;
    border-radius: 6px;
    background: #fff;

    .furnishText {
      font-size: 12px;
      color: #999999;
      text-align: right;
    }

    .goodsType {
      margin-bottom: 28px;
      display: flex;

      div {
        color: #333333;
        font-size: 24px;
        font-weight: bold;
      }

      img {
        height: 18px;
        flex-shrink: 0;
        //margin-left: -8px;
        //margin-top: -6px;
        margin-left: -1px;
        margin-top: -11px;
      }
    }

    .childsContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .childsItemContainer {
        .childsItemName {
          font-size: 16px;
          color: #999999;
          margin-bottom: 11px;
        }
      }
    }

    .pageSwitchContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .pageNum {
        display: flex;
        align-items: center;

        div:first-child {
          font-size: 14px;
          color: #999999;
          margin-right: 20px;
        }

        div:last-child {
          margin-top: -4px;
        }

        span {
          cursor: pointer;
        }
      }
    }
  }

  .goodItemContainer {
    padding: 12px;
    display: flex;
    height: 124px;
    border-radius: 6px;
    background: #FFFFFF;
    border: 1px solid #DFDFDF;
    margin-bottom: 12px;
    position: relative;
    cursor: pointer;

    .goods_pic {
      width: 100px;
      height: 100px;
      min-width: 100px;
      margin-right: 12px;
    }

    .topThreeIcon {
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .goodsTitle {
      color: #000000;
      font-size: 14px;
    }

    .goodItemBottomContainer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;

      .priceContainer {
        color: #B4272D;
        font-size: 18px;
        font-weight: bold;
      }

      .newPriceContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        div:first-child {
          color: #B4272D;
          font-size: 16px;
          font-weight: bold;
        }

        div:last-child {
          font-size: 14px;

          span:last-child {
            color: #B4272D !important;
            display: inline-block;
            margin: 0 2px;
          }
        }
      }
    }
  }

  //.goodItemContainer:last-child {
  //  margin-bottom: 0;
  //}

  .amazonHotList,
  .theRakutenHotList,
  .zozoHotList,
  .YaHooHotList {
    width: 685px;
    border-radius: 6px;
    padding: 30px;
    box-sizing: border-box;

    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;

      div {
        color: #333333;
        font-weight: bold;
        font-size: 24px;
      }
    }
  }

  .amazonHotList {
    background: linear-gradient(0deg, #FFFFFF, #FFEDD3);
    margin-right: 30px;
  }

  .theRakutenHotList {
    background: linear-gradient(0deg, #FFFFFF, #F9DBDB);
  }

  .YaHooHotList {

    background: linear-gradient(0deg, #FFFFFF, #F9E4E1);
    margin-right: 30px;
  }

  .zozoHotList {
    background: linear-gradient(0deg, #FFFFFF, #DDD7DD);
  }
}

/deep/ .el-carousel__arrow--right,
/deep/ .el-carousel__arrow--left {
  display: none;
  width: 100px;
  height: 100px;
  background: #ffffff;
  opacity: 0.6;
  border-radius: 50%;
}

/deep/ .el-carousel__arrow {
  background: rgba(255, 255, 255, 0.5);

  i {
    color: $homePageSubjectColor;
    font-size: 60px;
    font-weight: 700;
  }
}

/deep/ .el-carousel__button {
  display: none;
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
}

/deep/ .el-carousel__indicator.el-carousel__indicator--horizontal.is-active .el-carousel__button {
  outline: 3px solid $homePageSubjectColor;
  background-color: transparent;
}

.notHaveData {
  $imgSize: 255px;
  width: 265px;
  height: $imgSize;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: $imgSize/4;
  }
}
</style>
